// extracted by mini-css-extract-plugin
export default {"container":"Modal__container___3vtwr"};